import * as React from 'react';
import Menu from 'shared/components/Menu';
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

interface SidebarProps {
    brandContent?: React.FunctionComponent | React.ReactElement | string | false
    menuBottomInsert?: React.FunctionComponent | React.ReactElement | string | false
}

const Sidebar: React.FunctionComponent<SidebarProps> = (props) => {

    const activeRoute = (routeName: string) => {
        return window.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    };

    return (
        <div
            className="sidebar"
        >
            <div className="brand-content">
                {props.brandContent}
            </div>
            <div className="sidebar-wrapper">
                <PerfectScrollbar>
                    <Menu position="left" showLogOut={true} bottomInsert={props.menuBottomInsert} menuId={1} />
                </PerfectScrollbar>
            </div>
        </div>
    );
}

export default Sidebar;